import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { FundCallDetails } from 'src/Components/FundCalls/FundCallDetails';

const FundCallDetailsPage = () => {
  const { t } = useTranslation();

  return (
    <AnimatedRoutedDrawer title={t('fundCalls.details.title', 'Appel de fonds')}>
      {() => <FundCallDetails />}
    </AnimatedRoutedDrawer>
  );
};

export default FundCallDetailsPage;
